export default {
    xsdList: [],
}